import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Shield, Mail, KeyRound } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { toast } from 'sonner';
import { API } from '@/utils/api';
import axios from 'axios';

const SuperAdminLogin = ({ onLogin }) => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();
    if (!email || !password) { toast.error('Veuillez remplir tous les champs'); return; }
    setLoading(true);
    try {
      const res = await axios.post(`${API}/saas/auth/login`, { email, password });
      const { access_token, admin } = res.data;
      onLogin(access_token, admin);
      toast.success('Connexion super-admin réussie');
      navigate('/superadmin/dashboard');
    } catch (error) {
      toast.error(error.response?.data?.detail || 'Erreur de connexion');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-slate-950 p-4">
      <div className="w-full max-w-sm">
        <div className="p-8 rounded-2xl space-y-6" style={{ background: 'rgba(15, 20, 40, 0.85)', backdropFilter: 'blur(16px)', border: '1px solid rgba(99, 102, 241, 0.2)' }}>
          <div className="text-center space-y-3">
            <div className="mx-auto w-14 h-14 rounded-xl bg-gradient-to-br from-indigo-500 to-indigo-700 flex items-center justify-center">
              <Shield className="w-7 h-7 text-white" />
            </div>
            <h1 className="text-2xl font-bold text-white tracking-wide">Vortekio SaaS</h1>
            <p className="text-sm text-slate-400">Panneau Super-Administrateur</p>
          </div>
          <form onSubmit={handleLogin} className="space-y-4">
            <div className="space-y-1.5">
              <Label htmlFor="sa-email" className="flex items-center gap-2 text-slate-300 text-sm">
                <Mail className="w-4 h-4" /> Email
              </Label>
              <Input id="sa-email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} placeholder="superadmin@vortekio.ch" className="bg-white/10 border-white/20 text-white placeholder:text-slate-500 rounded-xl h-11" data-testid="superadmin-email-input" />
            </div>
            <div className="space-y-1.5">
              <Label htmlFor="sa-password" className="flex items-center gap-2 text-slate-300 text-sm">
                <KeyRound className="w-4 h-4" /> Mot de passe
              </Label>
              <Input id="sa-password" type="password" value={password} onChange={(e) => setPassword(e.target.value)} placeholder="••••••••" className="bg-white/10 border-white/20 text-white placeholder:text-slate-500 rounded-xl h-11" data-testid="superadmin-password-input" />
            </div>
            <Button type="submit" disabled={loading} className="w-full h-11 rounded-xl font-semibold mt-2 bg-indigo-600 hover:bg-indigo-700 text-white" data-testid="superadmin-login-button">
              {loading ? 'Connexion...' : 'Se connecter'}
            </Button>
          </form>
          <div className="text-center">
            <Button variant="link" onClick={() => navigate('/admin/login')} className="text-xs text-slate-500 hover:text-white" data-testid="back-to-admin-link">
              Accès administration garage
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SuperAdminLogin;
